import { render, staticRenderFns } from "./PauseOrderDialog.vue?vue&type=template&id=4ebfad50&"
import script from "./PauseOrderDialog.vue?vue&type=script&lang=ts&"
export * from "./PauseOrderDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports